import SolutionLayout, {
  type SolutionData,
} from "../../components/SolutionLayout";
import {
  BagIcon,
  BookIcon,
  InboxIcon,
} from "../../components/Icons";

const data: SolutionData = {
  path: "/solutions/dtc",
  eyebrow: "Solution · Direct-to-consumer",
  headline: "Answer \"where's my order?\" without leaving the ticket.",
  lede: "For brands selling online, most questions are about an order. ZopDesk shows the customer's Shopify orders next to the conversation, keeps your common answers as saved replies, and brings email, WhatsApp and calls into one inbox.",
  stats: [
    { value: "Shopify", label: "Orders in the sidebar", sub: "Profile, recent orders, fulfillment, LTV" },
    { value: "3", label: "Channels in one inbox", sub: "Email, WhatsApp and phone" },
    { value: "Saved", label: "Replies with variables", sub: "Customer name, ticket subject, agent name" },
  ],
  painFix: [
    {
      pain: "Agents jump between the Shopify admin and the inbox to answer \"where's my order?\" for the tenth time that hour.",
      fix: "Connect your Shopify store and the ticket sidebar shows the customer's recent orders, fulfillment status and lifetime value.",
    },
    {
      pain: "Refund and exchange answers get rewritten from scratch every time, and customers get slightly different answers from different agents.",
      fix: "Write those answers once as saved replies. The customer's first name and the ticket subject fill themselves in, and agents adjust before sending.",
    },
    {
      pain: "Customers email, then message on WhatsApp, then call. Each lands somewhere different.",
      fix: "Email, WhatsApp messages and Acefone calls all become tickets in the same inbox. Messages and calls are matched to customers by phone number, and a reply goes back on the channel it came from.",
    },
  ],
  highlights: [
    {
      Icon: BagIcon,
      title: "Shopify sidebar",
      body: "Profile, recent orders, fulfillment status and lifetime value, fetched when an agent opens the ticket.",
    },
    {
      Icon: BookIcon,
      title: "Saved replies",
      body: "Your refund, exchange and delivery answers, inserted in one click with the customer's details filled in.",
    },
    {
      Icon: InboxIcon,
      title: "Rules for busy days",
      body: "Tag or assign tickets whose subject or message mentions \"refund\" or \"return\", and spread new tickets across the team with round-robin.",
    },
  ],
  relatedSolutions: [
    { to: "/solutions/b2b", label: "B2B & wholesale" },
    { to: "/solutions/marketplaces", label: "Marketplaces" },
    { to: "/solutions/subscription", label: "Subscription" },
  ],
};

export default function SolutionDtc() {
  return <SolutionLayout data={data} />;
}
